import { backendApi } from "../dynamicBAseQuery";

export const RecruiterDetailsApi=backendApi.injectEndpoints({
    overrideExisting:true,
    endpoints:(builder)=>({
        forgetPassword1:builder.mutation({
            query:(args)=>({
                method:"POST",
                url:"forgetPassword1",
                body : {...args}
            })
        }),
        recruiterApproveOrSuspended:builder.mutation({
            query:(args)=> ({
                method:"POST",
                url:"recruiterApproveOrSuspended",
                body:{...args}
            })
        }),
        secondLevelAprroveOrSuspend:builder.mutation({
            query:(args)=> ({
                method:"POST",
                url:"secondLevelAprroveOrSuspend",
                body:{...args}
            })
        })

    })
})

export const {
    useForgetPassword1Mutation,
    useRecruiterApproveOrSuspendedMutation,
    useSecondLevelAprroveOrSuspendMutation,
   
}=RecruiterDetailsApi